// ============================================================
// HOME TEAM MOVING CO. — SITE CONTENT CONFIG
// Everything the business owner needs to edit lives in this file.
// Items marked [EDIT] are placeholders waiting for real details.
// ============================================================

export const BUSINESS = {
  name: "Home Team Moving Co.",
  shortName: "Home Team",
  tagline: "Veteran-Owned Moving & Hauling",
  phone: "(760) 468-1626",
  phoneHref: "tel:+17604681626",
  email: "MyChoice@HomeTeamMovingCo.Com",
  emailHref: "mailto:MyChoice@HomeTeamMovingCo.Com",
  facebookUrl: "https://www.facebook.com/profile.php?id=61592047718928",
  // License numbers (CAL-T / USDOT) will be added once issued
  licenseLine: "Licensed & Insured",
  hours: "Open 24 Hours · 7 Days a Week",
  region: "Southern California",
};

export const SERVICE_AREAS = [
  "Inland Empire",
  "Murrieta",
  "Temecula",
  "Lake Elsinore",
  "Menifee",
  "Wildomar",
  "Canyon Lake",
  "Corona",
  "North County San Diego",
  "San Diego",
  "Los Angeles",
  "Surrounding SoCal Areas",
];

// [EDIT] Starting prices below are market-typical ballparks — adjust each
// to your real rates. Exact pricing always requires a quote.
export const SERVICES = [
  { id: "residential-moving", title: "Residential Moving", category: "Core Moving", price: "From $450", description: "Full-service home, apartment, and estate relocations handled with white-glove care from door to door." },
  { id: "loading-unloading", title: "Loading & Unloading", category: "Labor Only", price: "From $120/hr", description: "Precision heavy lifting for rental trucks, PODS, and storage containers — packed tight, loaded safe." },
  { id: "packing-unpacking", title: "Packing & Unpacking", category: "Specialty Care", price: "From $150", description: "Room-by-room packing, wardrobe boxes, custom protection, and full unboxing at your new place." },
  { id: "furniture-moving", title: "Furniture Moving", category: "In-Home", price: "From $99", description: "In-home furniture shifting, room rearrangements, and safe positioning of heavy or oversized pieces." },
  { id: "disassembly-reassembly", title: "Furniture Disassembly & Reassembly", category: "Specialty Care", price: "From $89", description: "Bed frames, modular desks, exercise equipment, and patio sets — taken apart and rebuilt right." },
  { id: "junk-removal", title: "Junk Removal", category: "Hauling & Removal", price: "From $150", description: "Fast, eco-conscious removal of unwanted items, appliances, and debris with responsible disposal." },
  { id: "home-estate-cleanouts", title: "Home & Estate Cleanouts", category: "Hauling & Removal", price: "From $400", description: "Compassionate, thorough estate and probate cleanouts handled with respect for your family." },
  { id: "commercial-cleanouts", title: "Commercial Cleanouts", category: "Commercial", price: "From $500", description: "Office decommissioning, warehouse clearing, and retail turnover — on schedule, minimal downtime." },
  { id: "storage-cleanouts", title: "Storage Unit Cleanouts", category: "Hauling & Removal", price: "From $200", description: "Complete unit emptying, sorting, donation drop-offs, and disposal so you can close the account." },
  { id: "donation-pickup-delivery", title: "Donation Pickup & Delivery", category: "Logistics", price: "From $99", description: "Careful transport of donated furniture and goods to local Southern California charities." },
  { id: "appliance-pickup-delivery", title: "Appliance Pickup & Delivery", category: "Logistics", price: "From $129", description: "Safe haulage and placement of refrigerators, washers, dryers, and other heavy appliances." },
  { id: "post-move-cleanup", title: "Post-Move Cleanup", category: "Property Care", price: "From $150", description: "Broom-clean to deep-clean move-out service so the property is ready for its next chapter." },
  { id: "real-estate-turnover", title: "Real Estate / Property Turnover", category: "Property Care", price: "Custom quote", description: "Realtor-ready trash-outs, cleanouts, and staging moves for agents and property managers." },
];

export const MANIFESTO = [
  { chapter: "01", title: "Military-Grade Precision", content: "Every move is planned and executed like an operation — on time, on budget, zero surprises. We show up when we say we will, and we finish what we start." },
  { chapter: "02", title: "Honor in Every Handle", content: "Your belongings carry your life's memories. We wrap, pad, and move every piece with the same discipline and respect we brought to serving our country." },
  { chapter: "03", title: "SoCal Community First", content: "Born and built in Southern California. We hire local, serve local, and treat every customer's home like it belongs to one of our own." },
];

// Real customer reviews from the business Facebook page (verbatim text,
// real profile photos). To add more: copy name/text and link the post URL.
export const REVIEWS_RATING = "4.9";
export const REVIEWS = [
  {
    name: "Kelly Ren",
    date: "This week",
    photo: "/reviews/kelly.jpg",
    postUrl: "https://www.facebook.com/100022457484186/posts/pfbid0tfUWVABYPG5DQ2YCk5swVyjhZzsnmnZ3P1LAgVDT9txzKjZKtETV3nNUC1AZ8NZ9l/",
    text: "We hired Home Team Moving Co to do an unloading job. They did it very fast and clean cut. We highly recommend this team, and will definitely hire them again.",
  },
  {
    name: "Samantha Gonzales",
    date: "August 4",
    photo: "/reviews/samantha.jpg",
    postUrl: "https://www.facebook.com/samantha.gonzales.98871174/posts/pfbid02sTFJ62xBmtrnJ7tkFR5scJynSp4uF2vrna1adehtCG2TrSYQLPjeK8pqQF1L8pyQl",
    text: "I cannot say enough wonderful things about this moving team. We are beyond grateful for every single one of them.\n\nMoving is stressful on its own, but we were moving two households into one during an incredibly hot summer day. Emotions were high, the logistics were overwhelming, and yet this team showed up with professionalism, efficiency, kindness, and patience from beginning to end.\n\nThey worked tirelessly, stayed organized, and treated every single one of our belongings with exceptional care and respect. Not once did they make us feel like we were a burden, even with the countless boxes and furniture we had. Their positive attitudes and incredible work ethic made one of the most stressful days so much easier for our family.\n\nIf you\u2019re looking for movers you can truly trust, I recommend them without hesitation. They exceeded every expectation and gave us complete peace of mind throughout the entire process.\n\nThank you for your hard work, your kindness, and for taking such great care of our family and our home. We are incredibly grateful.\n\n10/10. Five stars. I would recommend them to anyone in a heartbeat!",
  },
  {
    name: "Amy Kemmerer Sinclair",
    date: "This week",
    photo: "/reviews/amy.jpg",
    postUrl: "https://www.facebook.com/amy.kemmerersinclair/posts/pfbid02thsXeorK9BoiAHfHf5WQEs85Fk9WCWdwuiYTyUVTpW94da4eNW7PGmp1s1inJbd2l",
    text: "The guys showed up on time. They were respectful of our home and property. The cost was reasonable for the job. Thanks. Amy S.",
  },
];

export const MARQUEE_ITEMS = [
  "Residential Moving",
  "Junk Removal",
  "Estate Cleanouts",
  "Packing & Unpacking",
  "Loading & Unloading",
  "Commercial Cleanouts",
  "Appliance Delivery",
  "Property Turnover",
];

export const IMAGES = {
  hero: "/truck.jpg",
  truckCity: "/work/fleet.jpg",
  boxes: "/work/bedroom.jpg",
  interior1: "/work/bins.jpg",
  interior2: "https://images.unsplash.com/photo-1602872029708-84d970d3382b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwzfHxtb2Rlcm4lMjBob3VzZSUyMGludGVyaW9yJTIwbHV4dXJ5fGVufDB8fHx8MTc4OTUxMjI5N3ww&ixlib=rb-4.1.0&q=85",
  loft: "https://images.unsplash.com/photo-1682184805271-11671b7ecf4c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBob3VzZSUyMGludGVyaW9yJTIwbHV4dXJ5fGVufDB8fHx8MTc4OTUxMjI5N3ww&ixlib=rb-4.1.0&q=85",
};

// Real on-the-job photos from the crew
export const WORK_PHOTOS = [
  { src: "/work/loaded-truck.jpg", alt: "A fully loaded Home Team Moving truck, packed tight and ramp down", label: "Packed tight, every time" },
  { src: "/work/bins.jpg", alt: "Neatly stacked packing bins ready for transport in a customer kitchen", label: "Packed & protected" },
  { src: "/work/cleanout.jpg", alt: "Furniture and household items staged for a cleanout job", label: "Cleanouts, start to finish" },
  { src: "/work/fleet.jpg", alt: "Home Team Moving Co. trucks on a job under Southern California palms", label: "Rolling across SoCal" },
];
